var _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOdfjellCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Odfjell") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0B2545"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.3 4.6) scale(0.2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9571 19.0106C19.1344 17.1844 17.0644 16.382 15.3128 17.2398L0 24.7104V32.7621L18.2586 23.8527C20.0102 22.9949 20.7798 20.8368 19.9571 19.0106Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7679 10.6822C27.0164 11.5399 26.2468 13.6981 27.0695 15.5243C27.8921 17.3504 29.9622 18.1528 31.7137 17.2951L47 9.85213V1.77277L28.7414 10.6822H28.7679Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2513 14.8326L27.6798 8.33033C28.9802 7.69394 30.3868 7.58327 31.6606 7.9153L39.0119 4.34599C35.2964 0.666003 29.6702 -0.468428 24.734 1.91111L11.4116 8.41334C6.47544 10.8205 3.71541 16.05 4.06042 21.3901L11.3586 17.8208C11.9424 16.548 12.9243 15.469 14.2513 14.8326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7753 19.7023L19.3467 26.2045C18.0463 26.8409 16.6398 26.9516 15.3659 26.6196L8.01468 30.1889C11.7301 33.8689 17.3563 35.031 22.2925 32.6238L35.6149 26.1215C40.5511 23.7143 43.3111 18.4849 42.9661 13.1447L35.668 16.7141C35.0841 17.9868 34.1022 19.0659 32.7753 19.7023Z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdfjellCircle);
export default __webpack_public_path__ + "static/media/odfjell-circle.b4935cf66781d88c92ed7ba2d60a262f.svg";
export { ForwardRef as ReactComponent };